import { Directive, Input, ElementRef, Renderer } from '@angular/core';

@Directive({
  selector: '[appSaAdminColumnSort]'
})
export class SaAdminColumnSortDirective {


  @Input() dataadmin: any[];
  @Input('sortKeyadmin') key: any;
  private toggleSort: boolean            = false;

  constructor (private el: ElementRef, private renderer: Renderer) {
  }

  ngOnInit () {
    this.renderer.listen(this.el.nativeElement, 'click', (event) => {
      let parentNode = this.el.nativeElement.parentNode;
      let children   = parentNode.children;
this.dataadmin.forEach(element => {
  if(element.ProductName== null || element.ProductName==undefined){
    element.ProductName="";
  }

  if(element.HaLoginUsername==null || element.HaLoginUsername==undefined){
    element.HaLoginUsername="";
  }
});
      if (this.dataadmin && this.key) {
        let sortedData: any = this.sortArray();
      }
      this.toggleSort = !this.toggleSort;
    })
  }

  sortArray (): Array<any> {
    let tempArray: Array<any> = this.dataadmin;
    tempArray.sort((a, b) => {
      let aKey = a[this.key];
        let str1: string = a[this.key].toLowerCase();
        let str2: string = b[this.key].toLowerCase();
        if (this.toggleSort) {
          if (str1 < str2) {
            return -1;
          }
          if (str1 > str2) {
            return 1;
          }
        }
        else {
          if (str1 > str2) {
            return -1;
          }
          if (str1 < str2) {
            return 1;
          }
        }
      return 0;
    });
    return tempArray;
  }

}
